import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL } from './URLConstants';
import { fetchDetails, scrollToTop } from './Api';


export default function About() {

    const [aboutdescription, setaboutdescription] = useState()

    useEffect(() => {
        const fetchData = async () => {
            const url = `${API_URL}/aboutdescription`;
            const data = await fetchDetails(url);
            if (data) {
                setaboutdescription(data);
            }
            scrollToTop();
        };

        fetchData();
    }, []);

    // const fetchAbout = async () => {
    //     await axios.get(`${API_URL}/aboutdescription`).then(({ data }) => {
    //         setaboutdescription(data)
    //     })
    // }



    return (
        <>
            <main id="tg-main" className="tg-main tg-haslayout">

                <section className="tg-sectionspace tg-haslayout tg-bg" id="tg-about">
                    <div className="container">
                        <div className="row">
                            <div className="tg-aboutus">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                    <div className="tg-sectionhead tg-textalignleft">
                                        <div className="tg-sectionheading">

                                            <h2>About ICDRI 2023</h2>
                                        </div>
                                        <div className="tg-description">
                                            <div dangerouslySetInnerHTML={{ __html: aboutdescription }}></div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </main >
        </>
    )
}
